export default __webpack_public_path__ + "bb121be67968015cc4e9e3a97c088e1b.png";